import { render, staticRenderFns } from "./ideallist.vue?vue&type=template&id=fa9b6868&scoped=true"
import script from "./ideallist.vue?vue&type=script&lang=js"
export * from "./ideallist.vue?vue&type=script&lang=js"
import style0 from "./ideallist.vue?vue&type=style&index=0&id=fa9b6868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9b6868",
  null
  
)

export default component.exports